var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ width: "20", height: "20", viewBox: "0 0 20 20", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    React.createElement(
      "defs",
      null,
      React.createElement("path", { d: "M4.3.5h11.4a3.8 3.8 0 0 1 3.8 3.8v11.4a3.8 3.8 0 0 1-3.8 3.8H4.3a3.8 3.8 0 0 1-3.8-3.8V4.3A3.8 3.8 0 0 1 4.3.5zm0 1.9a1.9 1.9 0 0 0-1.9 1.9v11.4c0 1.05.85 1.9 1.9 1.9h11.4a1.9 1.9 0 0 0 1.9-1.9V4.3a1.9 1.9 0 0 0-1.9-1.9H4.3zm2.341 7.322l2.015 2.015 4.703-4.702a.95.95 0 1 1 1.343 1.343l-5.374 5.374a.95.95 0 0 1-1.343 0l-2.687-2.687A.95.95 0 1 1 6.64 9.722z", id: "svg194527764a" })
    ),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement(
        "mask",
        { id: "svg194527764b", fill: "#fff" },
        React.createElement("use", { xlinkHref: "#svg194527764a" })
      ),
      React.createElement("use", { fillRule: "nonzero", xlinkHref: "#svg194527764a" }),
      React.createElement(
        "g",
        { mask: "url(#svg194527764b)", fill: "currentColor" },
        React.createElement("path", { d: "M0 0h20v20H0z" })
      )
    )
  );
});